import axios from 'axios'
import $ from 'jquery'
import { getCookie } from './index'
import _app from '../main'
import { baseURLCommon } from '@/contants'

export function request (config, baseURL = baseURLCommon, interceptors = false) {
  const options = {
    baseURL,
    timeout: 30000
  }
  const token = window.yhToken || getCookie('token') || '';
  if (token) {
    options.headers = {
      APPSession: token,
    }
  }
  const instance = axios.create(options)

  instance.interceptors.request.use(config => {
    return config
  }, err => {
    console.log(err)
  })

  instance.interceptors.response.use(res => {
    if (res.status !== 200) {
      _app.$toast.show('网络异常，请稍后')
      return;
    }
    if (!interceptors && res.data.status !== 1) {
      if (res.data.status === 401) {
        console.log('用户未授权')
      } else {
        _app.$toast.show(res.data.msg)
      }
    }
    return res.data
  }, err => {
    console.log('err', err)
  })

  return instance(config)
}

export function copyRequest ({url, type = 'post', data, callback}) {
  $.ajax({
    url,
    type,
    async: false,
    data: JSON.stringify(data),
    contentType: 'application/json',
    success: function (res) {
      if (res.status === 1) {
        !!callback && callback(res);
      }
    }
  });
}
